<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-dolly-flatbed" /> Compras
        </h2>
        <small class="text-muted">Controle as compras de sua empresa.</small>
      </div>
    </div>

    <hr />

    <div class="form-group">
      <label>Arquivo Xml:</label>
      <input
        ref="fileInput"
        type="file"
        class="form-control-file"
        accept="text/plain"
        @change="onFileSelected"
      />
    </div>

    <br />

    <b-card
      border-variant="ligth"
      header="Informações da NF-e"
      header-bg-variant="ligth"
      header-text-variant="grey"
      align="left"
    >
      <b-card-text>
        <div class="row mb-2">
          <div class="col-12">
            <h6 class="mr-2">Número da Nota:</h6>
            <span class="text-muted">{{ this.nfe.infNFe.ide.nNF }}</span>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">
            <h6>Natureza de operação:</h6>
            <span class="text-muted"> {{ this.nfe.infNFe.ide.natOp }}</span>
          </div>
          <div class="col-3">
            <h6 class="mr-2">Modelo:</h6>
            <span class="text-muted">{{ this.nfe.infNFe.ide.mod }}</span>
          </div>
          <div class="col-3">
            <h6 class="mr-2">Série:</h6>
            <span class="text-muted">{{ this.nfe.infNFe.ide.serie }} </span>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col">
            <h6>Data de Emissão:</h6>
            <span class="text-muted">
              {{ this.nfe.infNFe.ide.dhEmi | dateTimeBr }}</span
            >
          </div>
          <div class="col">
            <h6>Data de Saída:</h6>
            <span class="text-muted">{{
              this.nfe.infNFe.ide.dhSaiEnt | dateTimeBr
            }}</span>
          </div>
        </div>
        <div v-if="!checkPurchase">
          <span class="text-success"
            >* Esta entrada já foi lançada em
            {{ this.storedPurchase.saved_at | dateTimeBr }}
          </span>
        </div>
        <div v-if="checkPurchase">
          <span class="text-danger">* Esta entrada ainda não foi lançada </span>
        </div>
      </b-card-text>
    </b-card>
    <br />

    <b-card
      border-variant="ligth"
      header="Dados do emitente"
      header-bg-variant="ligth"
      header-text-variant="grey"
      align="left"
    >
      <b-card-text>
        <div class="row mt-2 mb-4">
          <div class="col-6">
            <h6 class="mr-2">Razão Social:</h6>
            <span class="text-muted">{{ this.nfe.infNFe.emit.xNome }}</span>
          </div>
          <div class="col-6">
            <h6 class="mr-2">Fantasia:</h6>
            <span class="text-muted">{{ this.nfe.infNFe.emit.xFant }}</span>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-4">
            <h6 class="mr-2">Cnpj:</h6>
            <span class="text-muted">{{ this.nfe.infNFe.emit.CNPJ }}</span>
          </div>
          <div class="col-4">
            <h6 class="mr-2">Inscrição estadual:</h6>
            <span class="text-muted">{{ this.nfe.infNFe.emit.IE }}</span>
          </div>
          <div class="col-4">
            <h6 class="mr-2">IE/ST:</h6>
            <span class="text-muted">{{ this.nfe.infNFe.emit.IEST }}</span>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-4">
            <h6 class="mr-2">Endereço:</h6>
            <span class="text-muted"
              >{{ this.nfe.infNFe.emit.enderEmit.xLgr }},
              {{ this.nfe.infNFe.emit.enderEmit.nro }}</span
            >
          </div>
          <div class="col-4">
            <h6 class="mr-2">Cidade/Estado</h6>
            <span class="text-muted"
              >{{ this.nfe.infNFe.emit.enderEmit.xMun }}/{{
                this.nfe.infNFe.emit.enderEmit.UF
              }}</span
            >
          </div>
          <div class="col-4">
            <h6 class="mr-2">Telefone:</h6>
            <span class="text-muted">{{
              this.nfe.infNFe.emit.enderEmit.fone
            }}</span>
          </div>
        </div>
        <div class="row mt-2 mb-4">
          <div class="col-6">
            <h6 class="mr-2">Bairro:</h6>
            <span class="text-muted">{{
              this.nfe.infNFe.emit.enderEmit.xBairro
            }}</span>
          </div>
          <div class="col-6">
            <h6 class="mr-2">Cep:</h6>
            <span class="text-muted">{{
              this.nfe.infNFe.emit.enderEmit.CEP
            }}</span>
          </div>
        </div>
        <div v-if="!checkVendor">
          <span class="text-success">* Esta Fornecedor esta cadastrado </span>
        </div>
        <template v-if="checkVendor">
          <div class="mr-4">
            <span class="text-danger mr-2">
              <p>
                * Este Fornecedor não esta cadastrado. O que deseja fazer deixar
                que o sistema cadastre ao salvar esta entrada ou vicular este
              </p>
              <p>fornendor a um registro já salvo na base de dados</p>
            </span>
            <button
              class="bl-2 d-block d-md-inline btn btn-success"
              @click="setVendorFormData()"
            >
              <i class="fas fa-check mr-2"></i>
              <span>Vincular</span>
            </button>
          </div>
        </template>
      </b-card-text>
    </b-card>
    <br />
    <b-card
      border-variant="ligth"
      header="Dados dos Produtos"
      header-bg-variant="ligth"
      header-text-variant="grey"
      align="left"
    >
      <div class="row">
        <div class="col-md-12">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Id</th>

                <th scope="col">Cód. Barras</th>

                <th scope="col">descrição</th>

                <th scope="col">CFOP</th>

                <th scope="col">Unidade</th>

                <th scope="col">Valor</th>

                <th scope="col">Quant.</th>

                <th scope="col">Fração</th>

                <th scope="col">Total</th>

                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
              </tr>
            </thead>

            <tbody
              v-for="(row, index) in this.form.purchase_products"
              :key="row.index"
            >
              <template v-if="filterStoredProducts(row.gtin)">
                <tr style="background-color: #fff">
                  <td>{{ row.product_id }}</td>

                  <td>{{ row.gtin }}</td>

                  <td>{{ row.nfe_description }}</td>

                  <td>{{ row.CFOP }}</td>

                  <td>{{ row.unit }}</td>

                  <td>{{ row.price | decimal }}</td>

                  <td>{{ row.quantity | decimal }}</td>

                  <td>12</td>

                  <td>{{ row.total | decimal }}</td>

                  <td></td>
                </tr>
              </template>
              <template v-else>
                <tr style="background-color: #f1f1f1">
                  <td>{{ row.product_id }}</td>

                  <td>{{ row.gtin }}</td>

                  <td>{{ row.nfe_description }}</td>

                  <td>{{ row.CFOP }}</td>

                  <td>{{ row.unit }}</td>

                  <td>{{ row.price | decimal }}</td>

                  <td>{{ row.quantity | decimal }}</td>

                  <td>12</td>

                  <td>{{ row.total | decimal }}</td>
                  <td>
                    <b-form-checkbox class="ml-3" switch size="md"
                      >Lançar estoque?</b-form-checkbox
                    >
                  </td>
                  <td>
                    <b-button
                      variant="light"
                      style="background-color: transparent"
                      class="border border-0 border-dark"
                      size="sm"
                      ><i class="fas fa-plus"></i> Novo</b-button
                    >
                  </td>
                  <td>
                    <b-button
                      variant="light"
                      style="background-color: transparent"
                      class="border border-0 border-dark"
                      size="sm"
                      ><i class="fas fa-sync"></i> Vincular</b-button
                    >
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </b-card>
    <div class="row">
      <div class="col-md-12 text-right">
        <router-link to="/compras">
          <button
            role="button"
            class="mb-2 mt-4 mr-2 bl-2 d-block d-md-inline btn btn-outline-primary"
            style="margin-left: 5px"
          >
            <i class="fas fa-times"></i> Cancelar
          </button>
        </router-link>
        <button
          class="mb-2 mt-4 mr-2 bl-2 d-block d-md-inline btn btn-primary"
          @click="handleStore('draft')"
        >
          <i class="fas fa-check mr-2"></i>
          <span>Salvar Rascunho</span>
        </button>
        <button
          class="mb-2 mt-4 bl-2 d-block d-md-inline btn btn-success"
          @click="handleStore('processed')"
        >
          <i class="fas fa-check mr-2"></i>
          <span>Confirmar Entrada</span>
        </button>
      </div>
    </div>

    <ProductForm ref="productForm" @stored="productHasregistered" />
    <PersonForm ref="personForm" @stored="vendorHasRegistered" />
  </div>
</template>

<script>
import Form from "./../../mixins/Form.js";
import Filters from "./../../mixins/Filters.js";
import moment from "moment";
import VueRouter from "./../../router";
import ProductForm from "@/components/product/forms/ProductForm";
import PersonForm from "./../../components/forms/PersonForm";

export default {
  components: {
    ProductForm,
    PersonForm,
  },

  data: function () {
    return {
      xml: {},

      nfe: {
        infNFe: {
          det: [],
          ide: {},
          emit: {
            enderEmit: {},
          },
        },
      },

      form: {
        id: null,
        operation_id: {},
        vendor_id: null,
        ship_company_id: {},
        number: {},
        serie: {},
        chave_nfe: {},
        emited_at: {},
        entry_at: {},
        product_total: {},
        addition: {},
        discount: {},
        shipping: {},
        net_total: {},
        raw_xml: {},
        vBC: {},
        vBCST: {},
        vCOFINS: {},
        vDesc: {},
        vFCP: {},
        vFCPST: {},
        vFCPSTRet: {},
        vFrete: {},
        vICMS: {},
        vICMSDeson: {},
        vII: {},
        vIPI: {},
        vIPIDevol: {},
        vNF: {},
        vOutro: {},
        vPIS: {},
        vProd: {},
        vST: {},
        vSeg: {},
        infCpl: {},
        notes: {},
        status: {},
        stock_status: {},
        finance_status: {},

        purchase_products: [],

        purchase_bills: [],

        purchase_vendor: {},

        purchaseStatus: {
          draft: {
            msg: "Salvo como Rascunho!",
          },

          processed: {
            msg: "Salvo com sucesso",
          },
        },
      },

      storedPurchase: null,

      vendor: {},

      // todo retornar todos os dados do protudo
      products: [],

      storedProducts: [],

      error: {},
    };
  },

  created() {
    this.$store.commit("pageHasLoaded");
  },

  computed: {
    checkPurchase() {
      return !!!this.form.id ? true : false;
    },

    checkVendor() {
      return !!!this.form.vendor_id ? true : false;
    },
  },

  methods: {
    onFileSelected(event) {
      this.xml = event.target.files[0];

      this.parseXml();
    },

    //carregar xml
    async parseXml(text) {
      let form = new FormData();

      form.append("xml", this.xml, "xml");

      await this.$store
        .dispatch("purchase/getParsedXml", form)
        .then((response) => {
          const { NFe } = response.data;

          this.nfe = NFe;

          this.setPurchaseFormData();

          this.setBillsFormData();

          this.purchaseHasRegistered();

          this.vendorHasRegistered();

          this.setVendorFormData();

          this.shipCompanyHasRegistered();

          this.productHasregistered();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //verificar se o xml esta cadastrado
    async purchaseHasRegistered() {
      const xmlId = this.nfe.infNFe.attributes.Id;

      await this.$store
        .dispatch("purchase/getPurchaseHasRegistered", {
          chaveNfe: xmlId,
        })
        .then((response) => {
          this.form.id = response.data.purchase.id;
          this.storedPurchase = response.data.purchase;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //verificar se o fornecedor esta cadastrado
    async vendorHasRegistered() {
      const vendorCnpj = this.nfe.infNFe.emit.CNPJ;

      await this.$store
        .dispatch("person/getvendorHasRegistered", {
          cnpj: vendorCnpj,
        })
        .then((response) => {
          this.form.vendor_id = response.data.person.id;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //verificar se a transaportadora esta cadastrada
    async shipCompanyHasRegistered() {
      const shipCnpj = this.nfe.infNFe.transp.transporta.CNPJ;

      await this.$store
        .dispatch("person/getShipCompanyHasRegistered", {
          cnpj: shipCnpj,
        })
        .then((response) => {
          this.form.ship_company_id = response.data.person.id;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //verificar se os produtos estão cadastrado
    productHasregistered() {
      const text = this.nfe.infNFe.det.map((row) => {
        return row.prod.cEAN;
      });

      this.form.purchase_products = [];

      this.$store
        .dispatch("product/getProductsHasRegistered", { gtin: text })
        .then((response) => {
          this.storedProducts = response.data.products;

          this.setProductFormData();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleStore(purchaseStatus) {
      this.form.purchaseStatus = purchaseStatus;
      this.storePurchase();
    },

    //salvar entrada
    storePurchase() {
      this.$store.dispatch("purchase/storePurchase", this.form);
    },

    //purchase
    setPurchaseFormData() {
      this.form.number = this.nfe.infNFe.ide.nNF;
      this.form.mod = this.nfe.infNFe.ide.mod;
      this.form.serie = this.nfe.infNFe.ide.serie;
      this.form.chave_nfe = this.nfe.infNFe.attributes.Id;
      this.form.emited_at = this.formatDateTime(this.nfe.infNFe.ide.dhEmi);
      this.form.entry_at = this.formatDateTime(this.nfe.infNFe.ide.dhSaiEnt);
      this.form.product_total = this.nfe.infNFe.total.ICMSTot.vBC;
      this.form.addition = this.nfe.infNFe.total.ICMSTot.vOutro;
      this.form.discount = this.nfe.infNFe.total.ICMSTot.vDesc;
      this.form.shipping = this.nfe.infNFe.total.ICMSTot.vFrete;
      this.form.net_total = this.nfe.infNFe.total.ICMSTot.vNF;
      this.form.vBC = this.nfe.infNFe.total.ICMSTot.vBC;
      this.form.vBCST = this.nfe.infNFe.total.ICMSTot.vBCST;
      this.form.vCOFINS = this.nfe.infNFe.total.ICMSTot.vCOFINS;
      this.form.vDesc = this.nfe.infNFe.total.ICMSTot.vDesc;
      this.form.vFCP = this.nfe.infNFe.total.ICMSTot.vFCP;
      this.form.vFCPST = this.nfe.infNFe.total.ICMSTot.vFCPST;
      this.form.vFCPSTRet = this.nfe.infNFe.total.ICMSTot.vFCPSTRet;
      this.form.vFrete = this.nfe.infNFe.total.ICMSTot.vFrete;
      this.form.vICMS = this.nfe.infNFe.total.ICMSTot.vICMS;
      this.form.vICMSDeson = this.nfe.infNFe.total.ICMSTot.vICMSDeson;
      this.form.vII = this.nfe.infNFe.total.ICMSTot.vII;
      this.form.vIPI = this.nfe.infNFe.total.ICMSTot.vIPI;
      this.form.vIPIDevol = this.nfe.infNFe.total.ICMSTot.vIPIDevol;
      this.form.vNF = this.nfe.infNFe.total.ICMSTot.vNF;
      this.form.vOutro = this.nfe.infNFe.total.ICMSTot.vOutro;
      this.form.vPIS = this.nfe.infNFe.total.ICMSTot.vPIS;
      this.form.vProd = this.nfe.infNFe.total.ICMSTot.vProd;
      this.form.vST = this.nfe.infNFe.total.ICMSTot.vST;
      this.form.vSeg = this.nfe.infNFe.total.ICMSTot.vSeg;
      this.form.infCpl = this.nfe.infNFe.infAdic.infCpl;
      this.form.notes = null;
      this.form.raw_xml = null;
    },

    setProductFormData() {
      for (let index in this.nfe.infNFe.det) {
        let product = this.getStoredProduct(
          this.nfe.infNFe.det[index].prod.cEAN
        );

        let purchase_products = {};

        purchase_products.product_id = product ? product.id : null;
        purchase_products.gtin = this.nfe.infNFe.det[index].prod.cEAN;
        purchase_products.nfe_description = this.nfe.infNFe.det[
          index
        ].prod.xProd;
        purchase_products.quantity = this.nfe.infNFe.det[index].prod.qTrib;
        purchase_products.price = this.nfe.infNFe.det[index].prod.vUnCom;
        purchase_products.total = this.nfe.infNFe.det[index].prod.vProd;
        purchase_products.NCM = this.nfe.infNFe.det[index].prod["NCM"];
        purchase_products.CEST = this.nfe.infNFe.det[index].prod["CEST"];
        purchase_products.CFOP = this.nfe.infNFe.det[index].prod["CFOP"];
        purchase_products.unit = this.nfe.infNFe.det[index].prod["uCom"];
        purchase_products.origin = 0;
        purchase_products.purchase_status = "d";
        purchase_products.can_move_stock = 1;
        purchase_products.stock_status = 0;

        this.form.purchase_products.push(purchase_products);
      }
    },

    setVendorFormData() {
      this.form.purchase_vendor.cnpj = this.nfe.infNFe.emit.CNPJ;
      this.form.purchase_vendor.crt = this.nfe.infNFe.emit.CRT;
      this.form.purchase_vendor.inscricao_estadual = this.nfe.infNFe.emit.IE;
      this.form.purchase_vendor.alias = this.nfe.infNFe.emit.xFant;
      this.form.purchase_vendor.name = this.nfe.infNFe.emit.xNome;
      this.form.purchase_vendor.cep = this.nfe.infNFe.emit.enderEmit.CEP;
      this.form.purchase_vendor.uf = this.nfe.infNFe.emit.enderEmit.UF;
      this.form.purchase_vendor.number = this.nfe.infNFe.emit.enderEmit.nro;
      this.form.purchase_vendor.district = this.nfe.infNFe.emit.enderEmit.xBairro;
      this.form.purchase_vendor.complement = this.nfe.infNFe.emit.enderEmit.xCpl;
      this.form.purchase_vendor.address = this.nfe.infNFe.emit.enderEmit.xLgr;
      this.form.purchase_vendor.city = this.nfe.infNFe.emit.enderEmit.xMun;
      this.form.purchase_vendor.country = this.nfe.infNFe.emit.enderEmit.xPais;
      (this.form.purchase_vendor.is_vendor = 1),
        (this.form.purchase_vendor.person_type = "j");
    },

    setBillsFormData() {
      for (let index in this.nfe.infNFe.cobr.dup) {
        let purchase_bills = {};

        purchase_bills.document = this.nfe.infNFe.cobr.dup[index].nDup;
        purchase_bills.payment_method = this.nfe.infNFe.pag.detPag.tPag;
        purchase_bills.due_date = this.nfe.infNFe.cobr.dup[index].dVenc;
        purchase_bills.value = this.nfe.infNFe.cobr.dup[index].vDup;
        purchase_bills.due_days = 30;

        this.form.purchase_bills.push(purchase_bills);
      }
    },

    formatDateTime(date) {
      let dateTime = moment(date).format("YYYY-MM-DD");
    },

    getStoredProduct(ean) {
      let productArr = this.storedProducts.filter((row) => {
        return row.gtin == ean;
      });

      if (productArr.length > 0) {
        return productArr[0];
      }
    },

    filterStoredProducts(tableEan) {
      let verifyIfStored =
        this.storedProducts.filter((row) => {
          return row.gtin == tableEan;
        }).length > 0;

      return verifyIfStored;
    },

    storeNewProduct(id, row) {
      this.$refs.productForm.open(id, row);
    },

    storeNewVendor(vendor) {
      this.$store
        .dispatch("person/storePerson", this.vendor)
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.row-list-product {
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-bottom: dashed 1px rgba(0, 0, 0, 0.125);
}

.row-list-first {
  padding-top: 1rem;
  /*border-top: dashed 1px rgba(0, 0, 0, 0.125);*/
  /* border-top: dashed 1px rgba(0, 0, 0, 0.125); */
}
</style>
